import React, { FC, useContext } from 'react';
import { AddEntityWatcherButton } from '../../../watchers/components/add-entity-watcher/AddEntityWatcherButton';
import { LawFirmActions } from './LawFirmActions';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import { LawFirmContext } from '../LawFirmContext';
import {
  SubHeaderActionSlider,
  SubHeaderSlide,
} from '../../../components/sub-header/slider/SubHeaderActionSlider';

type Props = {
  isVisible: boolean;
};

export const LawFirmActionSlider: FC<Props> = ({ isVisible }) => {
  return (
    <SubHeaderActionSlider isVisible={isVisible}>
      <LawFirmActionSliderContent />
    </SubHeaderActionSlider>
  );
};

const LawFirmActionSliderContent: FC = () => {
  const {
    lawFirmInfos: { lawOfficeIdGroup, name },
  } = useContext(LawFirmContext);
  const { openRestrictedModal } = useRestrictedModal();
  const source = 'law_firm_page';
  return (
    <>
      <SubHeaderSlide>
        <AddEntityWatcherButton
          entityIdParams={{ oid: lawOfficeIdGroup }}
          query={name}
          uniqueId={lawOfficeIdGroup}
          restrict={() =>
            openRestrictedModal({ source: 'want_to_follow_law_firm' })
          }
          source={source}
        />
      </SubHeaderSlide>
      <LawFirmActions name={name} source={source} />
    </>
  );
};
